module.exports = __webpack_public_path__ + "img/general-support.2126a7a4.svg";